export function isValidIanaTimeZone(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone }).resolvedOptions();
    return true;
  } catch {
    return false;
  }
}
export function isValidAwardTimeFormat(awardTime: string): boolean {
  const match = /^(\d{2}):(\d{2})$/.exec(awardTime);

  if (!match) return false;

  return Number(match[1]) <= 23 && Number(match[2]) <= 59;
}
